var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-check__info"},[_c('span',{staticClass:"info-message"},[_vm._v("\n        "+_vm._s(_vm.active === true ? _vm.$t('repeatTicketMsg') : '')+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa31b94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/checkTicket/TicketCompileInfo.vue
// module id = 2163
// module chunks = 0